import { create } from 'zustand';
import {
  fetchLatestVersion,
  compareVersions,
  clearCacheAndReload,
} from '@/services/versionService';

interface VersionState {
  /** 現在のアプリバージョン（ビルド時に埋め込み） */
  currentVersion: string;
  /** 最新バージョン（fetch結果） */
  latestVersion: string | null;
  /** 更新可能フラグ */
  isUpdateAvailable: boolean;
  /** チェック中フラグ */
  isChecking: boolean;
  /** バージョンチェック実行 */
  checkForUpdate: () => Promise<boolean>;
  /** キャッシュクリア + リロード */
  performUpdate: () => Promise<void>;
}

// ビルド時に埋め込まれるバージョン情報（デフォルト値はdevelopment用）
const getCurrentVersion = (): string => {
  try {
    return typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0-dev';
  } catch {
    return '0.0.0-dev';
  }
};

export const useVersionStore = create<VersionState>((set, get) => ({
  currentVersion: getCurrentVersion(),
  latestVersion: null,
  isUpdateAvailable: false,
  isChecking: false,

  checkForUpdate: async () => {
    set({ isChecking: true });

    try {
      const versionInfo = await fetchLatestVersion();

      if (!versionInfo) {
        set({ isChecking: false });
        return false;
      }

      const { currentVersion } = get();
      const isNewer = compareVersions(currentVersion, versionInfo.version) < 0;

      set({
        latestVersion: versionInfo.version,
        isUpdateAvailable: isNewer,
        isChecking: false,
      });

      return isNewer;
    } catch (error) {
      console.error('Version check failed:', error);
      set({ isChecking: false });
      return false;
    }
  },

  performUpdate: async () => {
    await clearCacheAndReload();
  },
}));
